<template>
  <div>
    <template v-for="(alert, index) in alerts">
      <CAlert :key="index" :color="alert.color" :show="5" closeButton>
        {{ alert.message }}
      </CAlert>
    </template>
  </div>
</template>

<script>
export default {
  name: "FlashAlert",
  data() {
    return {
      currentAlertCounter: 5,
    };
  },
  computed: {
    alerts() {
      return this.$store.state.flashAlert;
    },
  },
};
</script>
